import { defineConfig as r } from "tinacms";
const s = {
  name: "feed",
  label: "Feed Products",
  path: "_feed-products",
  format: "md",
  ui: {
    defaultItem: {
      title: "",
      layout: "feed"
    }
  },
  fields: [
    {
      name: "layout",
      label: "Layout",
      type: "string",
      required: !0,
      ui: {
        component: () => null
      }
    },
    {
      name: "title",
      label: "Title",
      type: "string",
      isTitle: !0,
      required: !0
    },
    {
      name: "date",
      label: "Date",
      type: "datetime"
    },
    {
      name: "description",
      label: "Description",
      type: "string",
      ui: {
        component: "textarea"
      }
    },
    {
      name: "ingredients",
      label: "Ingredients",
      type: "string",
      ui: {
        component: "textarea"
      }
    },
    {
      name: "directions",
      label: "Directions",
      type: "string",
      ui: {
        component: "textarea"
      }
    },
    {
      name: "general_analysis",
      label: "General analysis",
      type: "string",
      ui: {
        component: "textarea"
      }
    },
    {
      name: "analysis_table",
      label: "Analysis table",
      type: "object",
      list: !0,
      ui: {
        itemProps: (e) => ({ label: e.nutrients })
      },
      fields: [
        {
          name: "nutrients",
          label: "Nutrients",
          type: "string"
        },
        {
          name: "quantity",
          label: "Quantity",
          type: "string"
        }
      ]
    },
    {
      name: "product_photos",
      label: "Product photos",
      type: "object",
      list: !0,
      fields: [
        {
          name: "image",
          label: "Image",
          type: "image"
        }
      ]
    }
  ]
}, o = {
  name: "default",
  label: "Default",
  ui: {
    defaultItem: {
      title: "",
      layout: "default"
    }
  },
  fields: [
    {
      name: "title",
      type: "string",
      label: "Title",
      required: !0,
      isTitle: !0,
      searchable: !0
    },
    {
      name: "layout",
      type: "string",
      label: "Layout",
      required: !0,
      options: ["default", "order", "order-retailer"]
    },
    {
      name: "date",
      type: "datetime",
      label: "Date"
    },
    {
      name: "description",
      type: "string",
      label: "Description",
      ui: {
        component: "textarea"
      },
      description: "This text will show up at the top of the page in larger font"
    },
    {
      name: "permalink",
      type: "string",
      label: "Permalink"
    },
    {
      name: "body",
      type: "rich-text",
      label: "Body",
      parser: { type: "markdown", skipEscaping: "all" },
      isBody: !0
    }
  ]
}, p = {
  name: "default_pdfs",
  label: "Default page with pdfs",
  ui: {
    defaultItem: {
      title: "",
      layout: "default_pdfs",
      pdf_description: '<p>To place an order, <a href="info@barnyardorganics.com">email</a>   or call Barnyard Organics (902-887-3188).</p>'
    }
  },
  fields: [
    {
      name: "layout",
      label: "Layout",
      type: "string",
      required: !0,
      ui: {
        component: () => null
      }
    },
    {
      name: "title",
      label: "Title",
      type: "string",
      isTitle: !0,
      required: !0,
      searchable: !0
    },
    {
      name: "permalink",
      label: "Permalink",
      type: "string"
    },
    {
      name: "pdf_heading",
      type: "string",
      label: "PDF Heading",
      description: "This is the heading above your list of PDFs"
    },
    {
      name: "pdf_description",
      type: "string",
      label: "PDF Description",
      description: "This is the description below the heading and above the list of PDFs"
    },
    {
      type: "object",
      label: "PDFs",
      name: "pdfs",
      list: !0,
      ui: {
        itemProps: (e) => ({ label: e.title })
      },
      description: "List of links to PDFs",
      fields: [
        {
          name: "title",
          type: "string",
          label: "Title",
          isTitle: !0,
          required: !0
        },
        {
          type: "string",
          label: "PDF File",
          name: "link",
          description: "Upload the PDF that you want to link to"
        }
      ]
    }
  ]
}, m = {
  name: "faq",
  label: "FAQs",
  ui: {
    defaultItem: {
      title: "Frequently Asked Questions",
      layout: "feed-subpage",
      permalink: "/faq/"
    }
  },
  fields: [
    {
      name: "title",
      label: "Title",
      type: "string",
      isTitle: !0,
      required: !0,
      searchable: !0
    },
    {
      name: "layout",
      label: "Layout",
      type: "string",
      required: !0,
      ui: {
        component: () => null
      }
    },
    {
      name: "permalink",
      label: "Permalink",
      type: "string"
    },
    {
      name: "description",
      label: "Description",
      type: "string"
    },
    {
      name: "body",
      label: "Body",
      type: "rich-text",
      isBody: !0
    }
  ]
}, u = {
  name: "grid",
  label: "Links",
  ui: {
    defaultItem: {
      title: "",
      layout: "grid"
    }
  },
  fields: [
    {
      name: "title",
      label: "Title",
      type: "string",
      isTitle: !0,
      required: !0,
      searchable: !0
    },
    {
      name: "layout",
      label: "Layout",
      type: "string",
      required: !0,
      ui: {
        component: () => null
      }
    },
    {
      name: "description",
      label: "Description",
      type: "string",
      description: "This text will show up at the top of the page in larger font"
    },
    {
      name: "permalink",
      label: "Permalink",
      type: "string",
      description: 'This is the link to the page. If this is a "subpage" make sure you include the  parent page. For example: /services/custom-roasting/'
    },
    {
      name: "links",
      label: "Links",
      type: "object",
      list: !0,
      ui: {
        itemProps: (e) => ({ label: e.heading })
      },
      fields: [
        {
          name: "link",
          label: "Link",
          type: "reference",
          collections: ["page", "feed"],
          description: "Select the page you want to link to"
        },
        {
          name: "image",
          label: "Image",
          type: "image"
        },
        {
          name: "heading",
          label: "Heading",
          type: "string"
        },
        {
          name: "description",
          label: "Description",
          type: "string",
          ui: {
            component: "textarea"
          }
        }
      ],
      description: "This is a list of links to other pages. It will appear in a grid-format (with an image, title, and text)"
    }
  ]
}, c = {
  name: "description",
  label: "Description",
  type: "string"
}, d = {
  name: "image",
  label: "Image",
  type: "image"
}, a = (e, n, t) => {
  const i = [
    {
      name: "link",
      label: "Link",
      type: "reference",
      collections: ["page", "feed"]
    },
    {
      name: "heading",
      label: "Heading",
      type: "string"
    }
  ];
  return t != null && t.description && i.push(c), t != null && t.image && i.push(d), {
    name: e,
    label: n,
    type: "object",
    list: !0,
    ui: {
      itemProps: (l) => ({ label: l.heading })
    },
    fields: i
  };
}, b = {
  name: "home",
  label: "Home Page",
  ui: {
    defaultItem: {
      title: "Homepage",
      layout: "home",
      main_heading: "",
      ecofm_heading: "",
      ecofm_links: [],
      chicken_eggs: [],
      services: []
    }
  },
  fields: [
    {
      name: "title",
      type: "string",
      label: "Title",
      isTitle: !0,
      required: !0
    },
    {
      name: "permalink",
      label: "Permalink",
      type: "string"
    },
    {
      name: "layout",
      label: "Layout",
      type: "string",
      required: !0,
      ui: {
        component: () => null
      }
    },
    {
      name: "background",
      label: "Background",
      type: "image"
    },
    {
      name: "main_heading",
      label: "Main heading",
      type: "string"
    },
    {
      name: "ecofm_image",
      label: "Ecofm image",
      type: "image"
    },
    {
      name: "ecofm_heading",
      label: "Ecofm heading",
      type: "string"
    },
    a("ecofm_links", "Ecofm links", { description: !0 }),
    a("chicken_eggs", "Chicken eggs", { image: !0 }),
    a("services", "Services", { description: !0, image: !0 })
  ]
}, g = {
  name: "footer",
  label: "Footer",
  ui: {
    defaultItem: {
      Address: "",
      Phone: "",
      Email: "",
      social_media: []
    }
  },
  fields: [
    {
      name: "Address",
      label: "Address",
      type: "string"
    },
    {
      name: "Phone",
      label: "Phone",
      type: "string"
    },
    {
      name: "Email",
      label: "Email",
      type: "string"
    },
    {
      name: "social_media",
      label: "Social media",
      type: "object",
      list: !0,
      ui: {
        defaultItem: {
          name: "",
          link: ""
        },
        itemProps: (e) => ({ label: e.name })
      },
      fields: [
        {
          name: "name",
          label: "Name",
          type: "string",
          isTitle: !0,
          required: !0
        },
        {
          name: "link",
          label: "Link",
          type: "string"
        }
      ]
    }
  ]
}, y = {
  name: "order_form",
  label: "Order Form",
  ui: {
    defaultItem: {
      description: ""
    }
  },
  fields: [
    {
      name: "description",
      type: "rich-text",
      label: "page-description",
      description: "This text will show up at the top of the order form"
    },
    {
      type: "number",
      name: "hst",
      label: "HST Rate",
      description: "Current HST % (for items that require HST)"
    },
    {
      type: "object",
      name: "barnyard_organics",
      label: "Barnyard Organics",
      fields: [
        {
          type: "object",
          name: "products",
          label: "Products",
          list: !0,
          ui: {
            itemProps: (e) => ({ label: e.name })
          },
          fields: [
            {
              type: "string",
              name: "name",
              label: "Name"
            },
            {
              type: "string",
              name: "description",
              label: "Description"
            },
            {
              type: "number",
              name: "price",
              label: "Price"
            },
            {
              type: "number",
              name: "price_retailers",
              label: "Price (retailers)"
            },
            {
              type: "boolean",
              name: "hst",
              label: "HST",
              description: "Charge HST on this item?"
            }
          ]
        }
      ]
    },
    {
      type: "object",
      name: "bio_ag",
      label: "Bio-ag",
      fields: [
        {
          type: "object",
          name: "products",
          label: "Products",
          list: !0,
          ui: {
            itemProps: (e) => ({ label: e.name })
          },
          fields: [
            {
              type: "string",
              name: "name",
              label: "Name"
            },
            {
              type: "string",
              name: "description",
              label: "Description"
            },
            {
              type: "number",
              name: "price",
              label: "Price"
            },
            {
              type: "number",
              name: "price_retailers",
              label: "Price (retailers)"
            },
            {
              type: "boolean",
              name: "hst",
              label: "HST",
              description: "Charge HST on this item?"
            }
          ]
        }
      ]
    },
    {
      type: "object",
      name: "general_seed",
      label: "General Seed",
      fields: [
        {
          type: "object",
          name: "products",
          label: "Products",
          list: !0,
          ui: {
            itemProps: (e) => ({ label: e.name })
          },
          fields: [
            {
              type: "string",
              name: "name",
              label: "Name"
            },
            {
              type: "string",
              name: "description",
              label: "Description"
            },
            {
              type: "number",
              name: "price",
              label: "Price"
            },
            {
              type: "number",
              name: "price_retailers",
              label: "Price (retailers)"
            },
            {
              type: "boolean",
              name: "hst",
              label: "HST",
              description: "Charge HST on this item?"
            }
          ]
        }
      ]
    }
  ]
}, h = {
  name: "retailers",
  label: "Retailers",
  ui: {
    defaultItem: {
      new_brunswick: [],
      nova_scoti: [],
      pei: []
    }
  },
  fields: [
    {
      type: "string",
      list: !0,
      name: "NewBrunswick",
      label: "New Brunswick"
    },
    {
      type: "string",
      list: !0,
      label: "Nova Scotia",
      name: "NovaScotia"
    },
    {
      type: "string",
      list: !0,
      name: "Pei",
      label: "PEI"
    }
  ]
}, f = {
  name: "shopping_rates",
  label: "Shopping Rates",
  fields: [
    {
      type: "number",
      name: "fuel_surcharge",
      label: "Fuel Surcharge"
    },
    {
      type: "number",
      name: "fuel_surcharge_10000",
      label: "Fuel Surcharge",
      description: "For shipments greater than 10,000 lbs"
    },
    {
      type: "object",
      name: "new_brunswick",
      label: "New Brunswick",
      list: !0,
      ui: {
        itemProps: (e) => ({ label: e.location })
      },
      fields: [
        {
          type: "string",
          name: "location",
          label: "Location"
        },
        {
          type: "number",
          name: "price_1000",
          label: "Price / 100 pounds",
          description: "For shipments between 1,000 - 1,999 pounds"
        },
        {
          type: "number",
          label: "Price / 100 pounds",
          name: "price_2000",
          description: "For shipments between 2,000 - 4,999 pounds"
        },
        {
          type: "number",
          name: "price_5000",
          label: "Price / 100 pounds",
          description: "For shipments between 5,000 - 9,999 pounds"
        },
        {
          type: "number",
          name: "price_10000",
          label: "Price / 100 pounds",
          description: "For shipments between 10,000 - X pounds"
        }
      ]
    },
    {
      type: "object",
      name: "nova_scotia",
      label: "Nova Scotia",
      list: !0,
      ui: {
        itemProps: (e) => ({ label: e.location })
      },
      fields: [
        {
          type: "string",
          name: "location",
          label: "Location"
        },
        {
          type: "number",
          name: "price_1000",
          label: "Price / 100 pounds",
          description: "For shipments between 1,000 - 1,999 pounds"
        },
        {
          type: "number",
          label: "Price / 100 pounds",
          name: "price_2000",
          description: "For shipments between 2,000 - 4,999 pounds"
        },
        {
          type: "number",
          name: "price_5000",
          label: "Price / 100 pounds",
          description: "For shipments between 5,000 - 9,999 pounds"
        },
        {
          type: "number",
          name: "price_X",
          label: "Price / 100 pounds",
          description: "For shipments between 10,000 - X pounds"
        }
      ]
    },
    {
      type: "object",
      name: "pei",
      label: "PEI",
      list: !0,
      ui: {
        itemProps: (e) => ({ label: e.location })
      },
      fields: [
        {
          type: "string",
          name: "location",
          label: "Location"
        },
        {
          type: "number",
          name: "price_1000",
          label: "Price / 100 pounds",
          description: "For shipments between 1,000 - 1,999 pounds"
        },
        {
          type: "number",
          label: "Price / 100 pounds",
          name: "price_2000",
          description: "For shipments between 2,000 - 4,999 pounds"
        },
        {
          type: "number",
          name: "price_5000",
          label: "Price / 100 pounds",
          description: "For shipments between 5,000 - 9,999 pounds"
        },
        {
          type: "number",
          name: "price_X",
          label: "Price / 100 pounds",
          description: "For shipments between 10,000 - X pounds"
        }
      ]
    }
  ]
}, P = process.env.HEAD || process.env.VERCEL_GIT_COMMIT_REF || "tina", T = r({
  branch: P,
  clientId: process.env.TINA_PUBLIC_CLIENT_ID,
  token: process.env.TINA_TOKEN,
  build: {
    outputFolder: "admin",
    publicFolder: "/"
  },
  media: {
    tina: {
      mediaRoot: "images",
      publicFolder: "/"
    }
  },
  search: {
    tina: {
      indexerToken: process.env.TINA_SEARCH_TOKEN,
      stopwordLanguages: ["eng"]
    },
    indexBatchSize: 100,
    maxSearchIndexFieldLength: 100
  },
  schema: {
    collections: [
      {
        name: "page",
        label: "Pages",
        path: "_pages",
        format: "md",
        templates: [
          b,
          o,
          p,
          u,
          m
        ]
      },
      s,
      {
        name: "data",
        label: "Site Data",
        path: "_data",
        format: "json",
        templates: [
          g,
          y,
          h,
          f
        ]
      }
    ]
  }
});
export {
  T as default
};
